import { Component, Input, ViewChild, Output, EventEmitter, OnInit } from "@angular/core";
import { Observable } from 'rxjs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
const NOT_AUTHORIZED = 401;
const FORBIDDEN = 403;
@Component({
    selector: 'app-action-button',
    templateUrl: './action-button.component.html'
})
export class ActionButtonComponent implements OnInit {
    @Output() data = new EventEmitter();
    @Output() error = new EventEmitter();
    @Output() end = new EventEmitter();
    @Input() item$: Observable<Object>;
    @Input() button: any;
    buttonDefaults = {
        text: '',
        btnClass: '',
        iconClass: '',
        textColor: 'black'
    };
    @Input() shouldDisable = false;
    @BlockUI('action-button') blockUI: NgBlockUI;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    private inProgress = false;
    private errorVal: any = null;
    protected response: any = {};
    constructor() { }
    ngOnInit() {
        if (!this.button) this.button = this.buttonDefaults;
    }
    doing() {
        this.inProgress = true;
        this.blockUI.start();
    }
    finished() {
        this.inProgress = false;
        this.blockUI.stop();
    }
    click() {
        this.action();
    }
    action() {
        if (!this.item$) return;
        this.doing();
        this.item$.subscribe((value) => {
            this.response = value;
            this.data.emit(value);
        }, (error) => {
            this.finished();
            this.errorSwal.text = error.error.message;
            this.errorVal = error;
            if (error.status != NOT_AUTHORIZED && error.status != FORBIDDEN) this.errorSwal.show();
        }, () => {
            this.finished();
            if (this.response) this.successSwal.text = this.response.message;
            this.successSwal.show();
        })
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/action-button/action-button.component.ts